/** @jsx jsx */
import * as React from 'react';
import Integrations from '@clearkit/icons/identity/Integrations';
import { css, jsx } from '@emotion/core';

export interface CKIntegrationIconStackProps {
  integration: React.ReactElement;
  size?: number;
}

export const CKIntegrationIconStack: React.FC<CKIntegrationIconStackProps> = ({
  integration,
  size = 40,
}) => {
  return (
    <div
      css={css`
        position: relative;
        display: inline-block;
      `}
    >
      <Integrations width={size} height={size} />
      <div
        className="ck-box ck-box--card"
        css={css`
          position: absolute;
          bottom: 0;
          right: 0;
          width: calc(${size}px * 0.45);
          height: calc(${size}px * 0.45);
          border-radius: calc(${size}px * 0.1);
        `}
        style={{ padding: 2 }}
      >
        {React.cloneElement(integration, { width: '100%', height: '100%' })}
      </div>
    </div>
  );
};
